var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("DropdownFilter", {
    attrs: {
      placeholder: _vm.placeholder,
      value: _vm.value,
      options: _vm.industries,
      loading: _vm.$apollo.queries.industries.loading,
      max: _vm.max,
      multiple: _vm.multiple,
      customMultiStyleParent: "customWidthInput",
    },
    on: {
      search: (v) => (_vm.industrySearchString = v),
      input: _vm.handleInput,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }